import React from "react";
import { X, Check } from "lucide-react";
import { PAYMENT_MODES, ORDER_STATUSES } from "./useAdminOrders";

export default function EditOrderModal({ editingOrder, editForm, setEditForm, onClose, onSave }) {
  if (!editingOrder) return null;

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4" data-testid="edit-order-modal">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between p-4 border-b border-[--border] sticky top-0 bg-white">
          <h2 className="text-lg font-semibold" style={{ fontFamily: "Playfair Display, serif" }}>
            Edit Order: {editingOrder.order_number}
          </h2>
          <button onClick={onClose} className="btn-icon"><X size={18} /></button>
        </div>

        <div className="p-4 space-y-4">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-[11px] font-medium text-[--text-muted] block mb-1">Customer Name</label>
              <input
                type="text"
                value={editForm.customer_name || ""}
                onChange={(e) => setEditForm((f) => ({ ...f, customer_name: e.target.value }))}
                className="w-full text-sm border border-[--border] rounded-lg px-3 py-2"
              />
            </div>
            <div>
              <label className="text-[11px] font-medium text-[--text-muted] block mb-1">Phone</label>
              <input
                type="text"
                value={editForm.customer_phone || ""}
                onChange={(e) => setEditForm((f) => ({ ...f, customer_phone: e.target.value }))}
                className="w-full text-sm border border-[--border] rounded-lg px-3 py-2"
              />
            </div>
          </div>

          <div>
            <label className="text-[11px] font-medium text-[--text-muted] block mb-1">Shipping Address</label>
            <textarea
              value={editForm.customer_address || ""}
              onChange={(e) => setEditForm((f) => ({ ...f, customer_address: e.target.value }))}
              className="w-full text-sm border border-[--border] rounded-lg px-3 py-2"
              rows={2}
            />
          </div>
          <div>
            <label className="text-[11px] font-medium text-[--text-muted] block mb-1">Billing Address</label>
            <textarea
              value={editForm.billing_address || ""}
              onChange={(e) => setEditForm((f) => ({ ...f, billing_address: e.target.value }))}
              className="w-full text-sm border border-[--border] rounded-lg px-3 py-2"
              rows={2}
            />
          </div>

          <div className="grid grid-cols-3 gap-3">
            <div>
              <label className="text-[11px] font-medium text-[--text-muted] block mb-1">Amount (₹)</label>
              <input
                type="number"
                value={editForm.amount || ""}
                onChange={(e) => setEditForm((f) => ({ ...f, amount: parseFloat(e.target.value) || 0 }))}
                className="w-full text-sm border border-[--border] rounded-lg px-3 py-2"
              />
            </div>
            <div>
              <label className="text-[11px] font-medium text-[--text-muted] block mb-1">Discount %</label>
              <input
                type="number"
                value={editForm.discount_percent || ""}
                onChange={(e) => setEditForm((f) => ({ ...f, discount_percent: parseFloat(e.target.value) || 0, discount_amount: 0 }))}
                className="w-full text-sm border border-[--border] rounded-lg px-3 py-2"
              />
            </div>
            <div>
              <label className="text-[11px] font-medium text-[--text-muted] block mb-1">Discount Amount</label>
              <input
                type="number"
                value={editForm.discount_amount || ""}
                onChange={(e) => setEditForm((f) => ({ ...f, discount_amount: parseFloat(e.target.value) || 0, discount_percent: 0 }))}
                className="w-full text-sm border border-[--border] rounded-lg px-3 py-2"
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-[11px] font-medium text-[--text-muted] block mb-1">Payment Mode</label>
              <select
                value={editForm.payment_mode || ""}
                onChange={(e) => setEditForm((f) => ({ ...f, payment_mode: e.target.value }))}
                className="w-full text-sm border border-[--border] rounded-lg px-3 py-2"
              >
                {PAYMENT_MODES.map((m) => (<option key={m} value={m}>{m}</option>))}
              </select>
            </div>
            <div>
              <label className="text-[11px] font-medium text-[--text-muted] block mb-1">Status</label>
              <select
                value={editForm.status || ""}
                onChange={(e) => setEditForm((f) => ({ ...f, status: e.target.value }))}
                className="w-full text-sm border border-[--border] rounded-lg px-3 py-2"
              >
                {ORDER_STATUSES.map((s) => (<option key={s} value={s}>{s.charAt(0).toUpperCase() + s.slice(1)}</option>))}
              </select>
            </div>
          </div>

          <div>
            <label className="text-[11px] font-medium text-[--text-muted] block mb-1">Notes</label>
            <textarea
              value={editForm.notes || ""}
              onChange={(e) => setEditForm((f) => ({ ...f, notes: e.target.value }))}
              className="w-full text-sm border border-[--border] rounded-lg px-3 py-2"
              rows={2}
            />
          </div>
        </div>

        <div className="flex items-center justify-end gap-2 p-4 border-t border-[--border] sticky bottom-0 bg-white">
          <button onClick={onClose} className="btn-secondary">Cancel</button>
          <button onClick={onSave} className="btn-primary" data-testid="save-order-btn">
            <Check size={14} /> Save Changes
          </button>
        </div>
      </div>
    </div>
  );
}
